import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetCategoriesModelContextDocument,
  type GetCategoriesModelContextQuery,
  type GetCategoriesModelContextQueryVariables,
} from "~/features/admin/categories/gqls";

/**
 * Returns the static lookups the create/edit forms need:
 *   - categoryTypes (entity, relation)
 *   - relationTypes (per-tenant, scoped server-side)
 *
 * Each form lazy-suspends on first open.
 */
export function useCategoriesModelContext() {
  const { data } = useSuspenseQuery<GetCategoriesModelContextQuery, GetCategoriesModelContextQueryVariables>(
    GetCategoriesModelContextDocument,
  );
  return {
    categoryTypes: data?.categoryTypes ?? [],
    relationTypes: data?.relationTypes ?? [],
  };
}
